
<template>
  <loading v-model:active="isLoading"
           :can-cancel="false"
           :on-cancel="onCancel"
           :is-full-page="fullPage"/>
  <div class="toolbar" style="z-index: 1000">
    <div class="col-1 float-right">
      <new-menu-app revese="true"></new-menu-app>
    </div>
    <div class="col-5 float-left">
      <div style="background: #fff;border-radius: 50%;width: 38px;height: 38px;text-align: center;padding: 5px">
        <i class="fa-thin fa-heart"></i>
      </div>
      <div style="background: #fff;border-radius: 50%;width: 38px;height: 38px;text-align: center;padding: 5px;margin-top: 3px">

        <i class="fa-thin fa-share-nodes"></i>
      </div>
      <div style="background: #fff;border-radius: 50%;width: 38px;height: 38px;text-align: center;padding: 5px;margin-top: 3px">

        <back-icon></back-icon>
      </div>
    </div>
  </div>

  <template v-if="products.data.composition_id==10">
    <div style="padding-bottom: 20px">
      <template v-if="products.data.img_url">
        <div style="position: relative">
          <div style="border-radius: 0 0 50% 50%;overflow: hidden;">
            <img :src="products.data.img_url" width="100%" style="margin-top: -50px;height: 405px;object-fit: cover !important;">

          </div>
          
          <div class="clearfix"></div>
        </div>
        <div style="text-align: center;margin-top: 30px">

          <h4 style="direction: rtl">{{products.data.composition_title}}- {{products.data.cat_title}}</h4>

          <div style="width: 210px;margin: 10px auto;text-align: center;font-size: 15px;color: #fff;background: #1fa29d;padding: 10px;border-radius: 10px;direction: rtl" v-text="products.data.price_format+' ریال'">

          </div>
          <div style="width: 210px;margin: 10px auto;text-align: center;font-size: 13px;color: #1fa29d;background: #fff;padding: 10px;border-radius: 10px;direction: rtl;border: 1px solid #1fa29d" @click="addtoBasket1();">
            اضافه کردن به سبد خرید
          </div>
          <div class="tabsNew">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">معرفی پارچه</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">نظرات کاربران</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">کاربرد پارچه</button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab" ></div>
              <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab"></div>
              <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab"></div>
            </div>
          </div>
        </div>
        <div class="text-center pa-4" style="direction: rtl">
          <v-dialog
              v-model="dialog1"
              max-width="400"
              persistent
          >
            <v-card
                prepend-icon="mdi-basket"
                title="افزدون به سبد خرید"
                style="direction: rtl"
            >
              <div style="padding: 0 20px">
                <div class="col-2 float-right" v-if="products.data.composition_id!=10">
                  <div style="font-size: 18px;color: #fff;background: #1fa29d;margin: 0 5px;text-align: center;border-radius: 10px;height: 38px;padding-top: 5px;" @click="plus"><i class="fa-solid fa-plus"></i> </div>
                </div>
                <template v-if="products.data.composition_id!=10">
                  <div class="col-8 float-right" >
                    <div class="form-group" style="text-align: center;position: relative">
                      <input type="text" class="form-control" style="text-align: center;height: 38px;padding-top: 5px;padding-left: 92px;" v-model="value_basket" @change="changeN"/>
                      <h5 style="position: absolute;top: 3px;left: 8px;" v-text="products.data.uint_title"></h5>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-12 float-right" >
                    <div class="form-group" style="text-align: center;position: relative">
                      <input type="text" class="form-control" style="text-align: center;height: 38px;padding-top: 5px;padding-left: 92px;" v-model="value_basket" readonly/>
                      <h5 style="position: absolute;top: 3px;left: 8px;" v-text="products.data.uint_title"></h5>
                    </div>
                  </div>
                </template>
                <div class="col-2 float-right" v-if="products.data.composition_id!=10">
                  <div style="font-size: 18px;color: #fff;background: #7a0606;margin: 0 5px;text-align: center;border-radius: 10px;height: 38px;padding-top: 5px;" @click="minus"><i class="fa-solid fa-minus"></i> </div>
                </div>
                <div class="col-12 float-right" style="margin: 10px auto">
                  <div class="btn btn-success" style="width: 100%;background: #1fa29d;" @click="addtoBasket(products.data)">افزدون به سبد خرید</div>
                </div>
              </div>
              <template v-slot:actions>
                <v-spacer></v-spacer>
              </template>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <div class="clearfix"></div>
    </div>
  </template>
  <template v-else>
    <div style="padding-bottom: 20px">
      <template v-if="products.data.img_url">
        <div style="position: relative">
          <div style="border-radius: 0 0 50% 50%;overflow: hidden;">
            <img :src="products.data.img_url" width="100%" style="margin-top: -50px;height: 405px;object-fit: cover !important;">

          </div>
          <div v-if="products.data.price_discount > 0" style="bottom: -20px;position: absolute; left: 50%;">
            <div style="position: relative; left: -50%;">
              <v-img
                  :src="require('../assets/discount.png')"

                  contain
                  height="58"
                  width="177"
              />
              <div style="position: absolute;top:21px;font-size:11px;color: #fff;left: 18px">قیمت قبل : {{products.data.price_dis_format}}</div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div style="text-align: center;margin-top: 30px">
          <h1 v-text="products.data.cat_title" style="font-weight: 800"></h1>
          <h2 style="direction: rtl">کد کالا : {{products.data.title}}</h2>
          <h4 style="direction: rtl">{{products.data.composition_title}}</h4>

          <div style="width: 210px;margin: 10px auto;text-align: center;font-size: 15px;color: #fff;background: #1fa29d;padding: 10px;border-radius: 10px;direction: rtl" v-text="products.data.price_format+' ریال'">

          </div>
          <div style="width: 210px;margin: 10px auto;text-align: center;font-size: 13px;color: #1fa29d;background: #fff;padding: 10px;border-radius: 10px;direction: rtl;border: 1px solid #1fa29d" @click="addtoBasket1();">
            اضافه کردن به سبد خرید
          </div>
          <div class="tabsNew">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">معرفی پارچه</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">نظرات کاربران</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">کاربرد پارچه</button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab" ></div>
              <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab"></div>
              <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab"></div>
            </div>
          </div>
        </div>
        <div class="text-center pa-4" style="direction: rtl">
          <v-dialog
              v-model="dialog1"
              max-width="400"
              persistent
          >
            <v-card
                prepend-icon="mdi-basket"
                title="افزدون به سبد خرید"
                style="direction: rtl"
            >
              <div style="padding: 0 20px">
                <div class="col-2 float-right">
                  <div style="font-size: 18px;color: #fff;background: #1fa29d;margin: 0 5px;text-align: center;border-radius: 10px;height: 38px;padding-top: 5px;" @click="plus"><i class="fa-solid fa-plus"></i> </div>
                </div>
                <div class="col-8 float-right">
                  <div class="form-group" style="text-align: center;position: relative">
                    <input type="text" class="form-control" style="text-align: center;height: 38px;padding-top: 5px;padding-left: 92px;" v-model="value_basket" @change="changeN"/>
                    <h5 style="position: absolute;top: 3px;left: 8px;" v-text="products.data.uint_title"></h5>
                  </div>
                </div>
                <div class="col-2 float-right">
                  <div style="font-size: 18px;color: #fff;background: #7a0606;margin: 0 5px;text-align: center;border-radius: 10px;height: 38px;padding-top: 5px;" @click="minus"><i class="fa-solid fa-minus"></i> </div>
                </div>
                <div class="col-12 float-right" style="margin: 10px auto">
                  <div class="btn btn-success" style="width: 100%;background: #1fa29d;" @click="addtoBasket(products.data)">افزدون به سبد خرید</div>
                </div>
              </div>
              <template v-slot:actions>
                <v-spacer></v-spacer>
              </template>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <div class="clearfix"></div>
    </div>
  </template>

  <footer-app selectedItem="" :badge-cart="badgeCart"></footer-app>
</template>

<script >
import http from "@/plugins/axios";
import Loading from "vue-loading-overlay";
import NewMenuApp from "@/components/newMenuApp.vue";
import numeral from "numeral";
import FooterApp from "@/views/FooterApp.vue";
import BackIcon from "@/components/backIcon.vue";

export default {
  name: 'new-products',
  components: {BackIcon, FooterApp, NewMenuApp, Loading},
  data: () =>({
    value_basket : "1.0",
    dialog1: false,
    isLoading: true,
    badgeCart: 0,
    fullPage: true,
    product:[],
    products :  {
      data: [],
    },
  }),
  methods: {
    getCart() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/basket/get", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.badgeCart = response.data.data.items.length;
          })
          .catch((error) => {
          });
    },
    changeN(){
      this.value_basket =parseFloat(this.value_basket)
      this.value_basket = this.value_basket.toFixed(1);
      if(this.value_basket=="NaN")
        this.value_basket = 1.0;
      if(this.value_basket<=0.5){
        this.value_basket = "0.5";
      }
    },
    plus(){
      this.value_basket =parseFloat(this.value_basket)+0.1;
      this.value_basket = this.value_basket.toFixed(1);

    },
    minus(){
      this.value_basket =parseFloat(this.value_basket)-0.1;
      this.value_basket = this.value_basket.toFixed(1);
      if(this.value_basket<=0.5){
        this.value_basket = "0.5";
      }
    },
    getProduct(){

      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/product/"+this.$route.params.id, { headers: { Authorization: AuthStr } })
          .then(response => {
            this.products = response.data;
            this.isLoading = false;
            this.product=this.products.data;
            this.value_basket = this.product.basket;
          })
          .catch((error) => {

          });
    },
    getBasket(){

      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/basket/gets/"+this.$route.params.id, { headers: { Authorization: AuthStr } })
          .then(response => {
            console.log(response.data.data);
          })
          .catch((error) => {

          });
    },
    addtoBasket1(){
      this.dialog1 = true;
    }
    ,
    addtoBasket(product){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/basket/add",{
        product_id : product.id,
        val : this.value_basket,
      }, { headers: { Authorization: AuthStr ,"Content-type": "multipart/form-data"} })
          .then(response => {
            this.isLoading = false;
            this.dialog1 =false;
            this.$toast.success("محصول با موفقیت به سبد خرید اضافه شد.", {

              theme: "toasted-primary",
              position: "top-right",
              duration : 5000,

            });
            this.getCart();
          })
          .catch((error) => {

          });
    },
    setprice(product){
      let price =0;
      product.showprice =  numeral(product.val*product.price).format("0,0");
      return product;
    },
    colorRand(){
      return 'width: 30px;height: 30px;'+'#'+(Math.random()*0xFFFFFF<<0).toString(16)+';border-radius: 5px;float: left;margin: 0 5px';
    }
  },
  mounted() {
    this.getProduct();
    this.getCart();
    // this.getBasket();
  },
}
</script>

<style scoped>
.toolbar{
  padding: 20px;
  position: absolute;
  width: 100vw;
  height: 100px;
}
.toolbar i{
  color: #1fa29d !important;
  font-size: 20px;
}
.tabsNew{
  width: 300px ;
  margin: 20px auto 0;
  direction: rtl;
}
.nav-item{
  font-size: 9px !important;

}
.nav-link{
  color:#000 !important;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active{
  color: #1fa29d !important;
}
.tab-pane{
  padding: 10px;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}
</style>
<script setup>
</script>